import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import { TopbarContainer } from '..';
import {
  Page,
  LayoutSideNavigation,
  LayoutWrapperMain,
  LayoutWrapperSideNav,
  LayoutWrapperTopbar,
  LayoutWrapperFooter,
  CommProfJoinContent,
  Footer,
} from '../../components';
import config from '../../config';

import css from './CommProfJoinPage.module.css';

const CommProfJoinPageComponent = props => {
  const { scrollingDisabled, intl } = props;

  const tabs = [
    {
      text: intl.formatMessage({ id: 'JoinUsPage.joinusTabTitle' }),
      selected: false,
      linkProps: {
        name: 'JoinUsPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'CommProfJoinPage.commprofTabTitle' }),
      selected: true,
      linkProps: {
        name: 'CommProfJoinPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'DeafCommJoinPage.deafcommTabTitle' }),
      selected: false,
      linkProps: {
        name: 'DeafCommJoinPage',
      },
    },
    {
      text: intl.formatMessage({ id: 'InvestorsJoinPage.investorsTabTitle' }),
      selected: false,
      linkProps: {
        name: 'InvestorsJoinPage',
      },
    },
  ];
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'CommProfJoinPage.schemaTitle' }, { siteTitle });
  const schema = {
    '@context': 'http://schema.org',
    '@type': 'WebPage',
    name: schemaTitle,
  };
  return (
    <Page title={schemaTitle} scrollingDisabled={scrollingDisabled} schema={schema}>
      <LayoutSideNavigation>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="CommProfJoinPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperSideNav tabs={tabs} />
        <LayoutWrapperMain>
          <div className={css.content}>
            <h1 className={css.heading}>
              <FormattedMessage id="CommProfJoinPage.heading" />
            </h1>
            <CommProfJoinContent />
          </div>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSideNavigation>
    </Page>
  );
};

const { bool } = PropTypes;

CommProfJoinPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,

  // from injectIntl
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const CommProfJoinPage = compose(
  connect(mapStateToProps),
  injectIntl
)(CommProfJoinPageComponent);

export default CommProfJoinPage;
